export default [
  "Lonely Planet reviewed",
  "Free cancellation",
  "Free wifi",
  "Free parking",
  "Free breakfast",
  "Pool",
  "Hotel",
  "Hostel",
  "Bed and breakfast",
  "Apartment",
];



// WEBPACK FOOTER //
// ./assets/list/constants/popularFilters.js